import { connect } from "react-redux";
import * as Sentry from "@sentry/react";

import { auth, generateUser, updateUserProfile } from "_firebase";

import { actions as userActions } from "store/users";

import { loginUserAPI } from "utils/auth/api";

import { authErrors } from "utils/firebase";

import Register from "./";

const { fetchUserData, userFail, userStart, fetchUserCodeLib } = userActions;

const emptyDirs = {
    modelDir: {
        folders: {},
        models: [],
    },
    commDir: {
        folders: {},
        communities: [],
    },
};

const mapStateToProps = ({ user: { error } }) => ({
    error,
});

const mapDispatchToProps = (dispatch) => ({
    signUpWithEmailAndPassword: async (email, password) => {
        try {
            dispatch(userFail(authErrors("")));

            const { user } = await auth.createUserWithEmailAndPassword(email, password);
            const idToken = await auth.currentUser.getIdToken();

            await loginUserAPI({ idToken });
            await generateUser(user, {
                ...emptyDirs,
                name: "",
                nonErsUser: true,
                registrationComplete: false,
                userMeta: {},
            });

            localStorage.setItem("wasLoggedIn", "true");

            return {
                user,
                canMoveToNextStep: true,
            };
        } catch (error) {
            console.error("Error signing up with email and password", error);
            dispatch(userFail(authErrors(error)));

            return { error };
        }
    },
    createUser: async (event, user, accountDetails, reqTeamToCreate) => {
        event.preventDefault();
        try {
            const { firstName, lastName } = accountDetails;
            const fullName = `${firstName} ${lastName}`;

            await updateUserProfile(user.uid, {
                name: fullName,
                nonErsUser: true,
                registrationComplete: true,
                userMeta: {
                    agreedToTerms: true,
                    company: accountDetails.company,
                    eaErsCertified: false,
                    role: accountDetails.profession,
                },
                userPreferences: {
                    province: accountDetails.province,
                },
            });

            await dispatch(userStart());
            await dispatch(fetchUserData(user.uid));
            await dispatch(fetchUserCodeLib(user.uid));
            await user.sendEmailVerification();

            const profession = accountDetails.profession || [];
            const otherProfessionSelected = profession.includes("other");

            Sentry.withScope((scope) => {
                scope.setTransactionName(`New User Sign Up ${user.email}`);
                scope.setLevel("info");
                scope.setUser({ email: user.email, name: fullName, uid: user.uid });
                scope.setTag("auth", "register");
                scope.setTag("otherProfessionSelected", otherProfessionSelected);
                scope.setFingerprint(["new-user-signup", user.email]);
                Sentry.captureMessage("New User Sign Up");
                scope.setExtras({
                    name: fullName,
                    email: user.email,
                    uid: user.uid,
                    nonErsUser: !accountDetails.isRea,
                    reqTeamToCreate,
                    company: accountDetails.company,
                    profession,
                    otherProfessionSelected,
                });
                const error = new Error();
                error.name = `New User Sign Up ${user.email}`;
                error.message = `User ${firstName + " " + lastName} signed up. REGISTERED ENERGY ADVISOR: ${accountDetails.isRea}. REQUEST TEAM TO BE CREATED: ${reqTeamToCreate}. COMPANY: ${accountDetails.company}. PROFESSION: ${profession.join(", ") || "none"}. OTHER SELECTED: ${otherProfessionSelected}.`;
                scope.captureException(error);
            });

            return { success: true };
        } catch (error) {
            console.error("Error completing user registration", error);
            return { error };
        }
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(Register);
